export default __webpack_public_path__ + "static/media/service-etc.a1f0fe8b.png";